import { render } from "./Portfolio.vue?vue&type=template&id=dd45c3a6&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=ts"
export * from "./Portfolio.vue?vue&type=script&lang=ts"

import "./Portfolio.vue?vue&type=style&index=0&id=dd45c3a6&lang=scss&scoped=true"
import "./Portfolio.vue?vue&type=style&index=1&id=dd45c3a6&lang=scss"
script.render = render
script.__scopeId = "data-v-dd45c3a6"

export default script